<template>
  <layout-with-back-btn title="Partner dengan Kemungkinan Low Moving Stock">
    <div class="flex items-center justify-between gap-[10px] flex-wrap my-[24px]">
      <div class="d-flex rounded-lg align-items-center text-[#c2c2c2] px-[12px] py-[3px] border-[1px] border-[#e2e2e2] w-full sm:w-auto">
        <span
          class="k-search-normal-1 font-bold text-[24px] align-middle mx-[5px]"
        />
        <b-form-input
          v-model="mitraName"
          placeholder="Cari Nama Mitra"
          class="sm:!w-[250px] border-0 focus:!shadow-none !rounded-r-lg !text-[16px]"
          debounce="500"
        />
      </div>
      <div class="flex items-center gap-[8px] flex-wrap">
        <b-form-select
          v-model="period"
          :options="optionDateRangeLowMovingStock"
          class="csd !w-auto !border-[#e2e2e2] !text-[14px] !font-[500] !text-[#C2C2C2]"
        />
        <!-- <date-picker v-model="period" /> -->
        <b-button
          variant="primary"
          class="!flex items-center justify-center gap-5 inline-block !text-[14px] !font-[600] !rounded-lg h-[41px] w-full sm:w-auto"
          :disbaled="loadingExportData"
          @click="exportData"
        >
          <b-spinner
            v-if="loadingExportData"
            small
          />
          Export Data
        </b-button>
      </div>
    </div>

    <b-overlay
      :show="loading"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <b-table
        :items="items"
        :fields="lowMovingStockFields"
        thead-class="font-[500] text-[#333333]"
        show-empty
        empty-text="Tidak ada data yang ditampilkan."
        responsive
        sticky-header="500px"
        class="text-[#333333]"
        @scroll.native="handleScrollTable"
      >
        <template #cell(no)="data">
          {{ data.index + 1 }}
        </template>
        <template #head(unsold_quantity)="data">
          <div class="flex items-center gap-10 flex-wrap">
            {{ data.label }}<img
              id="lms-qty-info"
              class="w-[20px] h-[20px]"
              src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
              alt="info"
            >
            <BPopover
              target="lms-qty-info"
              triggers="hover"
              placement="bottomleft"
            >Jumlah barang yang terkena low moving stock</BPopover>
          </div>
        </template>
        <template #cell(partner_contact)="data">
          <div class="flex items-center gap-[4px]">
            <span class="k-Whatsapp text-[24px] text-[#10673E]" />
            <a
              :href="`https://wa.me/${data.value}`"
              target="_blank"
              class="text-[#10673E] underline hover:text-[#333333] hover:undeline transition"
            >{{ data.value }}</a>
          </div>
        </template>
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle" />
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>
    </b-overlay>

  </layout-with-back-btn>
</template>

<script>
import { DAY_MONTH_YEAR, TIME } from '@/libs/filterDate'
import { handleInfiniteScrollBTable } from '@/libs/scrollUtils'
import { downloadFileFromBlob } from '@/libs/downloadFile'
import LayoutWithBackBtn from '../../LayoutWithBackBtn.vue'
import { lowMovingStockFields, optionDateRangeLowMovingStock } from './config'

export default {
  components: {
    LayoutWithBackBtn,
  },
  data() {
    return {
      lowMovingStockFields,
      optionDateRangeLowMovingStock,
      mitraName: '',
      period: 'this_month',
      loadingExportData: false,
      items: [],
      loading: false,
      limit: 50,
      offset: 0,
      lastData: false,
    }
  },
  watch: {
    period() {
      this.getListData()
    },
    mitraName() {
      this.getListData()
    },
  },
  mounted() {
    this.getListData()
  },
  methods: {
    DAY_MONTH_YEAR,
    TIME,
    handleScrollTable(event) {
      handleInfiniteScrollBTable(event, !this.loading && !this.lastData, () => this.fetchData(false))
    },
    /**
     * Fetches low moving stock data from API based on period and search filters with infinite scroll
     */
    async fetchData(isNewSearch = true) {
      if (this.loading) return

      this.loading = true
      if (isNewSearch) {
        this.offset = 0
        this.lastData = false
      }

      const url = '/kompack/api/v1/dashboard/stock-recaps/alert-low-moving-stock'

      try {
        const response = await this.$http_new.get(url, {
          params: {
            offset: this.offset,
            limit: this.limit,
            month: this.period,
            search: this.mitraName,
          },
        })
        const { data } = response.data

        if (!data) {
          if (isNewSearch) {
            this.items = []
          }
          this.lastData = true
          return
        }

        if (isNewSearch) {
          this.items = data
        } else {
          this.items.push(...data)
        }

        this.offset += data.length
        this.lastData = data.length < this.limit
      } catch (err) {
        this.$toast_error({ message: 'Gagal mengambil data, silahkan coba lagi.' })
      } finally {
        this.loading = false
        if (this.isTabsLoading) {
          this.isTabsLoading = false
        }
      }
    },
    /**
     * Fetches low moving stock data from API based on period and search filters
     */
    getListData() {
      this.fetchData(true)
    },
    /**
     * Exports low moving stock data to Excel file
     */
    exportData() {
      this.loadingExportData = true
      this.$http_new.post('/kompack/api/v1/dashboard/stock-recaps/alert-low-moving-stock/export-data', null, {
        params: {
          search: this.mitraName,
          month: this.period,
        },
        responseType: 'blob',
      }).then(res => {
        if (!res.data) {
          throw new Error('no data')
        }
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        downloadFileFromBlob(blob, `partner_low_moving_stock_${this.period}.xlsx`)
        this.$toast_success({ message: 'Berhasil mengunduh file.' })
      }).catch(_err => {
        if (_err.response.data.message) {
          this.$toast_error({ message: 'Tidak ada data yang dapat diunduh.' })
        } else {
          this.$toast_error({ message: 'Gagal mengunduh file, silahkan coba lagi.' })
        }
      }).finally(() => {
        this.loadingExportData = false
      })
    },
  },
}
</script>

<style scoped>
.csd {
  background-image: url('https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/calendar.svg');
  background-size: 24px;
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 50px;
}
</style>
